import { render, staticRenderFns } from "./trainingDiagnosis.vue?vue&type=template&id=af461ff0&scoped=true&"
import script from "./trainingDiagnosis.vue?vue&type=script&lang=js&"
export * from "./trainingDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./trainingDiagnosis.vue?vue&type=style&index=0&id=af461ff0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af461ff0",
  null
  
)

export default component.exports